import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Platform} from "ionic-angular";
import {User} from "../user/user";
import { Observable } from 'rxjs';

/*
  Generated class for the FcmProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class FcmProvider {
  firebaseNative;

  constructor(
    private platform: Platform,
    private user: User
    ) {
    // if (platform.is('cordova')) {
    //   this.firebaseNative.onTokenRefresh().subscribe((token) => {
    //     this.saveToken(token)
    //   });
    // }
    platform.ready().then(() => {
      this.firebaseNative = (<any>window).FirebasePlugin;
    });
  }

  async initializeToken() {

    let token;

    if (this.platform.is('android')) {
      // token = await this.firebaseNative.getToken();
      this.firebaseNative.getToken((fcmToken) => {
        token = fcmToken;
      });
    }

    if (this.platform.is('ios')) {
      // token = await this.firebaseNative.getToken();
      token = await this.firebaseNative.getToken((fcmToken) => {
        token = fcmToken;
      });
      await this.firebaseNative.grantPermission();
    }

    console.log('THIS IS THE TOKEN FROM FCM', token)
    this.saveToken(token)
  }

  saveToken(token) {
    this.user.storeDeviceToken(token).subscribe(() => {
      console.log('ASSIGNED TO TOKEN', token)
    },
    err => {
      console.log('ERRORED OUT', err)
    });
  }

  onNotificationOpen() {
    return new Observable(observer => {
          (window as any).FirebasePlugin.onMessageReceived((response) => {
              observer.next(response);
          });
     });
}

  listenToNotifications(): Observable<any> {
    // return this.firebaseNative.onNotificationOpen();
    return this.onNotificationOpen();
  }

}



// WEBPACK FOOTER //
// ./src/providers/fcm/fcm.ts